module.exports = __webpack_public_path__ + "img/ijr-caminhao1.efa6ce62.jpg";